export const EMAIL_ATTACH_REQUEST_STATUS_NOTIFICATION_KEYS = {
  restored: {
    error: 'Notification.EmailAttachAndRestoreRequestErrorKey',
    text: 'Notification.RestoredRequestFromAnotherSectionTextKey',
    title: 'Notification.RequestRestoredromAnotherSectionKey',
  },
  statusChanged: {
    error: 'Notification.EmailAttachAndChangeStatusRequestErrorKey',
    text: 'Notification.RequestStatusChangedFromAnotherSectionTextKey',
    title: 'Notification.RequestStatusChangedFromAnotherSectionKey',
  },
}
